import React from "react";
import { Container, Row, Col, Card, CardBody, Button, Label, Input, FormFeedback } from "reactstrap";
import { withTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';

const colourStyles = {
  control: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled
      ? undefined
      : isSelected
        ? styles.backgroundColor
        : isFocused
          ? "#fff"
          : "#fff",
    ':hover': {
      ...styles[':hover'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    },
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const AddEuroWallet = props => {
  //meta title
  document.title = 'Add EUR to User Wallet';
  
  const { getRequest, postRequest } = useRequests();

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: null,
      amount: '',
      descriptiontype: '',
      description: '',
    },
    validationSchema: Yup.object({
      user: Yup.object().nullable().required('Please select a user'),
      amount: Yup.string()
        .matches(/^[0-9.]+$/, 'Please enter a valid amount')
        .required('Amount is required'),
      descriptiontype: Yup.string().required('Please select a description type'),
      description: Yup.string().when('descriptiontype', {
        is: (val) => val === 'Other',
        then: (schema) => schema.required('Description is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          u_id: values.user.value,
          amount: parseFloat(values.amount),
          descriptiontype: values.descriptiontype,
          description: values.description,
          type: 'Credit',
          currency_type: 'Euro'
        });
        
        const res = await postRequest('add-user-euro-wallet', jsonpar);
        if (res && res.code === 200) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
          
          // Reset form
          validation1.resetForm();
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Add EUR';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let tempArr = [];
      res.data.forEach(element => {
        let temp = {
          label: `${element.first_name} ${element.last_name} (${element.email})`,
          value: element.u_id,
        };
        tempArr.push(temp);
      });
      tempArr = [{
        options: tempArr
      }];
      setUsersData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    handleLoadGetUsers();
  }, []);

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Add EUR to User Wallet")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col md={6} xs="12">
                      <div className="mb-3 Register-Select2">
                        <Label className="form-label">Select User :</Label>
                        <Select 
                          styles={colourStyles} 
                          value={validation1.values.user} 
                          onChange={(e) => {
                            validation1.setFieldValue('user', e);
                            validation1.setFieldTouched('user', true);
                          }}
                          onBlur={() => validation1.setFieldTouched('user', true)}
                          options={UsersData} 
                          classNamePrefix="select2-selection"
                          placeholder="Search and select user..."
                          isClearable
                        />
                        {validation1.touched.user && validation1.errors.user ? (
                          <div className="invalid-feedback" style={{ display: 'block', color: '#f46a6a', backgroundColor: 'transparent', fontSize: '12px !important', marginTop: '0.25rem' }}>
                            {validation1.errors.user}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={6} xs="12">
                      <div className="mb-3">
                        <Label className="form-label">EUR Amount :</Label>
                        <Input
                          name="amount" 
                          type="text" 
                          placeholder="Enter EUR amount"
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.amount || ""}
                          invalid={
                            validation1.touched.amount && validation1.errors.amount ? true : false
                          }
                        />
                        {validation1.touched.amount && validation1.errors.amount ? (
                          <FormFeedback type="invalid">{validation1.errors.amount}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3">
                        <label className="form-label">Description Type : </label>
                        <select
                          className="form-select"
                          name="descriptiontype"
                          value={validation1.values.descriptiontype}
                          onChange={(e) => {
                            validation1.setFieldValue('descriptiontype', e.target.value);
                            validation1.setFieldTouched('descriptiontype', true);

                            // 🔑 clear description when not "Other"
                            if (e.target.value !== 'Other') {
                              validation1.setFieldValue('description', '');
                              validation1.setFieldTouched('description', false);
                            }
                          }}
                        >
                          <option value="">Select</option>
                          <option value="Manually Added">Manually Added</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </Col>
                    {validation1.values.descriptiontype === 'Other' && (
                      <Col md={12} xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Description :</Label>
                          <textarea
                            className="form-control"
                            name="description"
                            rows="3"
                            placeholder="Enter description for this transaction"
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.description || ""}
                            style={{ 
                              borderColor: validation1.touched.description && validation1.errors.description ? '#f46a6a' : '#ced4da' 
                            }}
                          />
                          {validation1.touched.description && validation1.errors.description ? (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{validation1.errors.description}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      )}
                  </Row>
                  <div className="text-left mt-2">
                    <Button
                      type="button" 
                      color="primary"
                      id="submit1"
                      onClick={(e) => {
                        e.preventDefault();
                        validation1.handleSubmit();
                        return false;
                      }}
                      className="me-2"
                    >
                      Add EUR
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(AddEuroWallet);